// import ReactDOM from 'react-dom';
// import {Provider} from 'react-redux'
// import { SnackbarProvider} from 'notistack';
// import {ThemeProvider,} from '@material-ui/styles';
// import 'react-toastify/dist/ReactToastify.css';
// import WebSocketProvider from './modules/ninVerification/webSockets/WebSocket'
// import store from "./data/redux/store";
// import './index.css';
// import AppRoutes from './AppRoutes';
// import * as serviceWorker from './serviceWorker';
// import theme from "./theme";
// import './assets/fonts/font.css'

// ReactDOM.render(
//     <Provider store={store}>
//         <ThemeProvider theme={theme}>
//           <SnackbarProvider maxSnack={3}>
//             <WebSocketProvider>
//               <AppRoutes />
//             </WebSocketProvider>
//           </SnackbarProvider>
//         </ThemeProvider>
//     </Provider>, 
//     document.getElementById('root'));

// serviceWorker.register();

import { createRoot } from 'react-dom/client';
import {Provider} from 'react-redux'
import {store} from "./data/redux/store";
// Axios
import axios from 'axios'
import {Chart, registerables} from 'chart.js'
import { Toaster } from 'react-hot-toast';

// Apps
import {MetronicI18nProvider} from './_metronic/i18n/Metronici18n'
/**
 * TIP: Replace this style import with dark styles to enable dark mode
 *
 * import './_metronic/assets/sass/style.dark.scss'
 *
 * TIP: Replace this style import with rtl styles to enable rtl mode
 *
 * import './_metronic/assets/css/style.rtl.css'
 **/
import './_metronic/assets/sass/style.scss'
import './_metronic/assets/sass/style.react.scss'
import './index.css';
import {AppRoutes} from './app/routing/AppRoutes'
import {AuthProvider, setupAxios} from './app/modules/auth'
import WebSocketProvider from './data/WebSockets/WebSocket'
import IdleTimerWrapper from './app/modules/sharedComponents/IdleTimerWrapper'
import { ViewNotification } from './app/modules/sharedComponents/ViewNotification';

setupAxios(axios)

Chart.register(...registerables)

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <Provider store={store}>
      <MetronicI18nProvider>
          <AuthProvider>
            <WebSocketProvider>
              <AppRoutes />
              <Toaster />
              <IdleTimerWrapper />
              <ViewNotification />
            </WebSocketProvider>
          </AuthProvider>
      </MetronicI18nProvider>
      {/* <ReactQueryDevtools initialIsOpen={false} /> */}
  </Provider>
)